function shipmentsSingleBookingBuyersConsolController() {
  const vm = this;

  /** Initial values for the controller */
  vm.orderByField = "LCL_JOB_REFERENCE";
  vm.reverse = false;
}

export default shipmentsSingleBookingBuyersConsolController;
